import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/form-comments"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formCommentsApi = createApi({
    reducerPath: "formCommentsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ["FormElementComments"],
    endpoints: (builder) => ({
        getFormElementComments: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                tmp.append('element-id', params.elementId);
                tmp.append('movement-id', params.movementId);
                tmp.append('is_resolved', params.isResolved);
                if (params.ccId) {
                    tmp.append('cc-id', params.ccId);
                }
                return `/?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ["FormElementComments"],
        }),
        createFormElementComment: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ["FormElementComments"],
        }),
        deleteFormElementComment: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["FormElementComments"],
        }),
        setFormElementCommentResolvedStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/${id}/resolved-status/${status}`,
                method: "POST",
            }),
            invalidatesTags: ["FormElementComments"],
        }),
        getFormComments: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                tmp.append('movement-id', params.movementId);
                params.type && tmp.append('type', params.type);
                return `/template/${params.templateId}?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ["FormElementComments"],
        }),
    }),
});

export const {
    useLazyGetFormElementCommentsQuery,
    useCreateFormElementCommentMutation,
    useDeleteFormElementCommentMutation,
    useSetFormElementCommentResolvedStatusMutation,
    useGetFormCommentsQuery
} = formCommentsApi;
